import {
  Component,
  Inject,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { WebinarpageService } from '../../webinarpage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MetaService } from 'src/app/shared/services/meta.service';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-webinars-article-video',
  templateUrl: './webinars-article-video.component.html',
  styleUrls: ['./webinars-article-video.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
  encapsulation: ViewEncapsulation.None,
})
export class WebinarsArticleVideoComponent implements OnInit, OnDestroy, OnChanges {
  @Input() pageData: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private webinarPageService: WebinarpageService,
    private router: Router,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService
  ) {
    this.subscriptions = [];
    this.getUrl = this.router.url;
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  articleData: any;
  subscriptions: Subscription[];
  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };

  public controlIcon: boolean = true;
  playButton() {
    let vid: any = this.document.querySelector('video');
    if (vid.paused) {
      vid.play();
      this.controlIcon = false;
    } else {
      vid.pause();
      this.controlIcon = true;
    }
  }

  ngOnInit(): void {}
  ngOnChanges(): void {

    let data = this.pageData?.fields;
    if (data != null) {
      this.articleData = {
        header: data?.title || '',
        datestamp: data?.webinarAndPodcastDate || '',
        readtime: data?.listeningTime || '',
        paragraph: data?.webinarsAndPodcastsArticleContent || '',
      };
      this.metaBody.title = data?.seoMetadataReference?.fields?.title || 'Verto: Cross-border payments platform for businesses';
      this.metaBody.description = data?.seoMetadataReference?.fields?.description || 'Verto: Cross-border payments platform for businesses across the globe.';
      this.metaBody.type = 'Webinars And Podcasts Article';
      this.metaBody.url = this.getUrl;
      this.metaBody.image = data?.webinarAndPodcastMedia?.[0]?.fields?.file?.url;
      this.meta.updateOG(this.metaBody);
      this.meta.updateMeta(data?.seoMetadataReference?.fields);
      this.canonical.setCanonicalURL();
    }
  }

  getCorrectArticle(d: any) {}

  social(a: string) {
    const isServer = !isPlatformBrowser(this.platformId);
    if (isServer) return;
    let title = this.articleData?.header;
    let url = `https://verto.co${this.getUrl}`;
    let twitterHandle = 'Verto';
    let facebook = 'https://facebook.com/sharer/sharer.php?u=' + url;
    let twitter =
      'https://twitter.com/intent/tweet?url=' +
      url +
      '&text=' +
      title +
      '&via=' +
      twitterHandle;
    let linkedin =
      'https://www.linkedin.com/shareArticle?url=' + url + '&title=' + title;

    let b = '';

    if (a === 'linkedin') {
      b = linkedin;
    }
    if (a === 'twitter') {
      b = twitter;
    }
    if (a === 'facebook') {
      b = facebook;
    }

    let params = `width=600,height=400,left=100,top=100`;

    window.open(b, a, params);
  }
  copyUrl() {
    let copy = location.href;
    navigator.clipboard.writeText(copy);
  }
}
